import { useDocumentUploader } from '@/hooks/useDocumentUploader'
import { IUploaderProps, TUploadedFile } from '@/types/uploader'
import { Alert } from '@dgshahr/ui-kit'
import FileUploader, { FileType } from '@dgshahr/ui-kit/Form/FileUploader'

const TaxRegCert = ({ formik, corrections }: IUploaderProps) => {
  const { values } = formik
  const { handleUpload, handleReplace, handleDelete } = useDocumentUploader(formik)

  const fieldName = 'TAX_REGISTRATION_CERTIFICATE'
  const files: TUploadedFile[] = values[fieldName] ?? []
  const targetFile: TUploadedFile | undefined = files.at(files.length - 1)

  const handleChange = (file: File | undefined): void => {
    if (file) {
      if (values.TAX_REGISTRATION_CERTIFICATE[0]?.id) {
        handleReplace(fieldName, file)
      } else {
        handleUpload(fieldName, file)
      }
    }
  }
  const handleDeleteClick = (uploadedFile: TUploadedFile): void => {
    handleDelete(fieldName, uploadedFile)
  }
  return (
    <div className="flex flex-col gap-8">
      {corrections?.[fieldName] && (
        <div className="flex flex-col gap-4">
          <Alert
            size="small"
            title="اصلاحیه‌"
            variant="error"
            text={corrections[fieldName].comment}
          />
        </div>
      )}
      <label htmlFor="tax-reg-cert" className="font-p2-medium text-gray-500">
        تصویر گواهی ثبت مالیاتی را بارگذاری کنید، توجه کنید که تصویر حتماً دارای
        کد رهگیری باشد.
      </label>

      <FileUploader
        className="w-fit"
        fileInputProps={{
          id: 'tax-reg-cert',
          className: 'ss02',
          required: true,
          description: 'فرمت‌های قابل قبول PNG , SVG یا PDF\nحداکثر حجم تا 5Mb',
          helperProps: {
            hintMessage: ''
          },
          title: 'تصویر گواهی ثبت مالیاتی',
          accept:
            'image/png, image/jpeg, image/jpg, image/PNG, image/JPEG, image/JPG , application/pdf'
        }}
        mode="single"
        files={
          targetFile?.file || targetFile?.src
            ? (targetFile as FileType)
            : undefined
        }
        onChange={handleChange}
        previewProps={{
          leftButton: {
            onClick: (uploadedFile) =>
              handleDeleteClick(uploadedFile as TUploadedFile)
          },
          rightButton: false
        }}
      />
    </div>
  )
}

export default TaxRegCert
